function ClientPopup($rootDom, option) {
    var clbList = [];

    var m = {
        init: function () {
            m.setup();
            m.onClickClose();
            m.onWindowResize();
            m.initAddressAutocomplete();
        },

        setup: function() {
            if (!option) {
                option = {
                    title: false
                }
            }

            var _width = Core.Config.CartNotification.Width + 20;

            if (Core.IsMobile()) {
                _width = Core.Cache.$window.width();
            }

            $popup = $rootDom.kendoWindow({
                title: option.title,
                width: _width,
                visible: false,
                iframe: false,
                modal: true,
                resizable: false,
                actions: ["Close"],
                pinned: true,
                draggable: false,
                appendTo: '#page-wrap',
                animation: false,
                close: function() {
                    $('body').css('overflowY', '');
                    clbList.forEach(function(clb) { clb(); });
                }
            });

            $popup.find('input[type="checkbox"]').uniform();

            var popUpObj = $popup.data("kendoWindow");
            popUpObj.wrapper.addClass('addressbook-popup__wrapper');

            //override css
            if ($popup.prop('id') === 'addNewClient') {
                popUpObj.wrapper.css('padding-top', '50px');
                popUpObj.wrapper.find('.k-window-titlebar').css('margin-top', '-45px');
            }

            $('body').css('overflowY', 'hidden');

            popUpObj.open();

            setTimeout(function() {
                m.setHeight($popup);
            }, 100);
        },

        onClickClose: function() {
            $('.addressbook-btnclose, .addressbook-btncancel').on('click', m.close);
        },

        onWindowResize: function() {
            $(window).on('resize', m.setHeight);
        },

        close: function() {
            $rootDom.data('kendoWindow').close();
        },

        onClose: function(clb) {
            clbList.push(clb);
        },

        setHeight: function() {
            //set max-height of popup-content
            var $content = $rootDom.find('.addressbook-popup__content')
                , $buttonWrap = $rootDom.find('.addressbook-popup__buttonwrap')
                , buttonH = $buttonWrap.is(':visible') ? $buttonWrap.outerHeight() : 0
                , popupH = $rootDom.outerHeight() + 80 + buttonH //80px is gap top and bottom
                , windowH = window.innerHeight
                , $header = $rootDom.find('.addressbook-header');

            if ($header.length === 0) $header = $rootDom.siblings('.k-window-titlebar');

            var contentH = windowH - buttonH - $header.outerHeight() - 130; //130 = padding-top + padding-bottom + (top + bottom popup's position)
            contentH = (contentH > 600) ? 600 : contentH;
            $content.css('max-height', contentH + "px");
        },

        initAddressAutocomplete: function() {
          var $content = $rootDom.find('.addressbook-popup__content');
          var $autocomplete = $content.find('.addressAutocomplete');
          if ($autocomplete.length > 0) {
            var $input = $autocomplete.find('input.addressAutocomplete-input');
            var autoObj = $input.data('kendoAutoComplete');

            // make sure we init kendo once
            if (!autoObj) Core.Engine.handleAddressAutocomplete();
          }
        },
    };

    return m;
}
